module.exports = __webpack_public_path__ + "media/images/product/b1-3fda13e7c06c10a21ca94a5a71f8cd76.png";